import { Navigate, Outlet } from 'react-router';
import { useSession } from '../../lib/session.js';
import { useActor } from '../../lib/capabilities.js';

/**
 * Guards the authenticated half of `/apply/*` (the draft, fee, and submit
 * steps). Deliberately NOT `RequireAuth`: that component hard-requires
 * `signed-in` with no path for an unauthenticated visitor, and the
 * pre-qualification and sign-up steps of this same tree need exactly that —
 * an anonymous visitor is not an error here, it is the normal starting
 * state (see CLAUDE.md's Applications section, step 1).
 *
 * Signed-in as anything but APPLICANT (a staff member, an owner, a tenant)
 * is redirected to their own tree rather than shown an apply-flow screen
 * built around "your application" that has nothing to do with their
 * account.
 */
export function RequireApplicant() {
  const { state } = useSession();
  const actor = useActor();

  if (state.status === 'loading') {
    return <p className="muted shell__main">Checking your session…</p>;
  }

  if (state.status === 'signed-out') {
    return <Navigate to="/apply" replace />;
  }

  if (actor && actor.actorType !== 'APPLICANT') {
    return <Navigate to={actor.actorType === 'STAFF' ? '/staff' : '/portal'} replace />;
  }

  return <Outlet />;
}
